import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

function toFormData(payload, imageFile) {
    const fd = new FormData();
    Object.entries(payload || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null) fd.append(key, value);
    });
    if (imageFile) fd.append("image", imageFile);
    return fd;
}

export default function usePopularTopics({ includeInactive = true, withCounts = false } = {}) {
    const [topics, setTopics] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchTopics = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const res = await axios.get(`${API_BASE}/api/popular-topics`, {
                params: {
                    include_inactive: includeInactive,
                    with_counts: withCounts,
                },
                withCredentials: true,
            });
            setTopics(Array.isArray(res.data) ? res.data : []);
        } catch (e) {
            setError(e?.response?.data?.error || e.message || "Beliebte Themen konnten nicht geladen werden.");
        } finally {
            setLoading(false);
        }
    }, [includeInactive, withCounts]);

    useEffect(() => {
        fetchTopics();
    }, [fetchTopics]);

    const createTopic = useCallback(async (payload, imageFile = null) => {
        const res = await axios.post(`${API_BASE}/api/popular-topics`, toFormData(payload, imageFile), {
            headers: { "Content-Type": "multipart/form-data" },
            withCredentials: true,
        });
        await fetchTopics();
        return res.data;
    }, [fetchTopics]);

    const updateTopic = useCallback(async (id, payload, imageFile = null) => {
        const res = await axios.put(`${API_BASE}/api/popular-topics/${id}`, toFormData(payload, imageFile), {
            headers: { "Content-Type": "multipart/form-data" },
            withCredentials: true,
        });
        await fetchTopics();
        return res.data;
    }, [fetchTopics]);

    const deleteTopic = useCallback(async (id) => {
        const res = await axios.delete(`${API_BASE}/api/popular-topics/${id}`, { withCredentials: true });
        await fetchTopics();
        return res.data;
    }, [fetchTopics]);

    return { topics, loading, error, fetchTopics, createTopic, updateTopic, deleteTopic };
}
